import React, { Component } from 'react';
import {Redirect,Link} from 'react-router-dom';
import $ from 'jquery';
import {
  Button,
  ButtonGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

class ManagePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: new Array(2).fill(false),
			dropdownOpen1: new Array(2).fill(false),
			dropdownOpen2: new Array(2).fill(false),
			dropdownOpen3: new Array(2).fill(false),
		}
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
	}
	
	toggle(i) {
		const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen: newArray
		});
	}
	toggle1(i) {
		const newArray = this.state.dropdownOpen1.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen1: newArray
		});
	}
	toggle2(i) {
		const newArray = this.state.dropdownOpen2.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen2: newArray
		});
	}
	toggle3(i) {
		const newArray = this.state.dropdownOpen3.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen3: newArray
		});
	}
	
  render() {
	
    return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
		  <a className="navbar-brand" href="javascript:;"><i className="fa fa-list"></i>&nbsp; Manage</a>
		  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon"></span>
		  </button>
		  <div className="collapse navbar-collapse" id="navbarSupportedContent">
			<ul className="navbar-nav mr-auto">
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen2[0]} toggle={() => { this.toggle2(0); }}>
				<DropdownToggle caret color="user">
					Users
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/users/alluser" className="dropdown-item" >User List</Link>
						<Link to="/users/adduser" className="dropdown-item" >Add User</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen[0]} toggle={() => { this.toggle(0); }}>
				<DropdownToggle caret color="task">
					Task
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/task/list" className="dropdown-item" >Task List</Link>
						<Link to="/task/addtask" className="dropdown-item" >Add Task</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen1[0]} toggle={() => { this.toggle1(0); }}>
				<DropdownToggle caret color="group">
					Group
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/group/groups" className="dropdown-item" >Group Category</Link>
						<Link to="/group/summary" className="dropdown-item" >Manage Group</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen3[0]} toggle={() => { this.toggle3(0); }}>
				<DropdownToggle caret color="homework">
					Homework
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/homework/assign" className="dropdown-item" >Add Homework</Link>
						<Link to="/homework/manage" className="dropdown-item" >Manage Homework</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			</ul>
		  </div>
		</nav>
    )
  }
}

export default ManagePage;


// WEBPACK FOOTER //
// ./src/views/ManagePage/ManagePage.js